import { buildUrl, extractPublicId } from 'cloudinary-build-url';

export function useCloudinaryOptimisedImage(imageUrl: string, width: number) {
  if (!imageUrl?.includes('res.cloudinary.com')) {
    return imageUrl;
  }

  const publicId = extractPublicId(imageUrl);

  return buildUrl(publicId, {
    cloud: {
      cloudName: 'hevo'
    },
    transformations: {
      resize: {
        type: 'scale',
        width
      }
    }
  });
}
